import type { RunGoalChecks } from "@/profitability/settings/types";

/** How a period stands against the owner's own numbers, in a few words. */
export const runGoalHeadline = (checks: RunGoalChecks) => {
  if (checks.status === "unavailable")
    return "Not checked against your numbers";
  const off = checks.failed.length;
  if (!off) return "Matches your numbers";
  return off === 1 ? "1 figure off" : `${off} figures off`;
};

/** Whether the period matched every figure the owner gave. */
export const runGoalMatches = (checks: RunGoalChecks) =>
  checks.status === "checked" && checks.failed.length === 0;
